import { useState } from 'react'

import { Alert } from '../components/ui.tsx'
import { api } from '../lib/api.ts'
import { useAuth } from '../lib/auth.tsx'
import { useAction } from '../lib/hooks.ts'
import { formatDate } from '../lib/format.ts'

const ROLE_LABELS: Record<string, string> = {
  admin: 'Administrátor',
  coach: 'Trenér',
  client: 'Klient',
}

export function SettingsPage(): React.JSX.Element {
  const { user } = useAuth()

  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [repeat, setRepeat] = useState('')
  const [done, setDone] = useState(false)
  const [mismatch, setMismatch] = useState(false)

  const change = useAction(() => api.auth.changePassword(current, next))

  const submit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault()

    if (next !== repeat) {
      setMismatch(true)
      return
    }
    setMismatch(false)

    const result = await change.run()
    if (result) {
      setDone(true)
      setCurrent('')
      setNext('')
      setRepeat('')
    }
  }

  return (
    <main className="page">
      <div className="page__header">
        <div>
          <h1>Nastavení</h1>
          <p>Tvůj účet a přihlašovací údaje.</p>
        </div>
      </div>

      <div className="grid grid--wide">
        <div className="card">
          <h2>Účet</h2>
          <dl className="play__params" style={{ marginTop: '1rem' }}>
            <div className="play__param">
              <dt>Jméno</dt>
              <dd>{user?.name}</dd>
            </div>
            <div className="play__param">
              <dt>E-mail</dt>
              <dd style={{ fontSize: '0.9rem' }}>{user?.email}</dd>
            </div>
            <div className="play__param">
              <dt>Role</dt>
              <dd>{ROLE_LABELS[user?.role ?? ''] ?? user?.role}</dd>
            </div>
            <div className="play__param">
              <dt>Účet od</dt>
              <dd style={{ fontSize: '0.9rem' }}>{formatDate(user?.createdAt ?? null)}</dd>
            </div>
          </dl>
          <p className="field__help">
            Jméno a e-mail mění administrátor. Pokud něco nesedí, ozvi se mu.
          </p>
        </div>

        <div className="card">
          <h2>Změna hesla</h2>

          <form onSubmit={(e) => void submit(e)} style={{ marginTop: '1rem' }}>
            {change.error && <Alert>{change.error}</Alert>}
            {mismatch && <Alert>Nová hesla se neshodují.</Alert>}
            {done && <Alert kind="success">Heslo bylo změněno. Ostatní zařízení byla odhlášena.</Alert>}

            <label className="field">
              <span className="field__label">Stávající heslo</span>
              <input
                type="password"
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>

            <label className="field">
              <span className="field__label">Nové heslo</span>
              <input
                type="password"
                value={next}
                onChange={(e) => setNext(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
              <span className="field__help">Alespoň 8 znaků.</span>
            </label>

            <label className="field">
              <span className="field__label">Nové heslo znovu</span>
              <input
                type="password"
                value={repeat}
                onChange={(e) => setRepeat(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>

            <button type="submit" className="btn btn--primary" disabled={change.pending}>
              {change.pending ? 'Měním…' : 'Změnit heslo'}
            </button>
          </form>
        </div>
      </div>
    </main>
  )
}
